<template>
  <div class="hik-video-plugin">
    <!-- 插件容器 -->
    <div id="divPlugin"></div>
    <pre v-if="opInfo" class="hik-video-log">{{ opInfo }}</pre>
  </div>
</template>

<script>
const $ = window.$ || window.jQuery || window.Zepto
export default {
  name: 'HKVideo',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      g_iWndIndex: 0,
      deviceIdentify: '',
      isLoginSuccess: false,
      channels: [],
      selectedChannel: '',
      opInfo: '',
      rtspPort: 554,
      initTimer: null,
      channelTimer: null,
      playTimer: null,
      destroyed: false,
      loginForm: {
        ip: this.info.ip,
        port: this.info.port,
        username: this.info.username,
        password: this.info.password
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.initTimer = window.setTimeout(() => {
      this.initPlugin()
    }, 2000)
  },
  activated() {
    if (this.destroyed && this.info && this.info.ip) {
      this.destroyed = false
      this.initTimer = window.setTimeout(() => {
        this.initPlugin()
      }, 200)
    }
  },
  deactivated() {
    this.teardownPlugin()
  },
  beforeDestroy() {
    this.teardownPlugin()
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    showOPInfo(info) {
      const time = new Date().toLocaleString()
      this.opInfo = `${time} ${info}\n` + this.opInfo
      if (this.opInfo.split('\n').length > 20) {
        this.opInfo = this.opInfo.split('\n').slice(0, 20).join('\n')
      }
    },

    initPlugin() {
      if (this.destroyed) return
      if (!window.WebVideoCtrl) {
        this.showOPInfo('未检测到海康WebVideoCtrl插件，请先安装！')
        return
      }
      const _this = this
      window.WebVideoCtrl.I_InitPlugin({
        bWndFull: true,
        iWndowType: 1,
        cbSelWnd: (xmlDoc) => {
          _this.g_iWndIndex = parseInt($(xmlDoc).find("SelectWnd").eq(0).text(), 10)
        },
        cbInitPluginComplete: () => {
          if (this.destroyed) return
          window.WebVideoCtrl.I_InsertOBJECTPlugin("divPlugin").then(() => {
            if (this.destroyed) {
              this.teardownPlugin()
              return
            }
            window.WebVideoCtrl.I_CheckPluginVersion().then((bFlag) => {
              if (bFlag) {
                this.showOPInfo('检测到新的插件版本，请升级！')
              } else {
                this.showOPInfo('插件初始化成功，版本为最新')
                this.handleResize()
                this.handleLogin()
              }
            })
          }).catch(() => {
            this.showOPInfo('插件初始化失败，请确认已安装插件！')
          })
        }
      })
    },

    handleLogin() {
      console.log('触发了登录:', this.info)
      const { ip, port, username, password } = this.info
      if (!ip || !port) {
        this.showOPInfo('IP和端口不能为空！')
        return
      }
      if (!username) {
        this.showOPInfo('账号不能为空！')
        return
      }
      this.deviceIdentify = `${ip}_${port}`
      window.WebVideoCtrl.I_Login(ip, 101, port, username, password, {
        timeout: 1000,
        success: (xmlDoc) => {
          this.showOPInfo(`${this.deviceIdentify} 登录成功！`)
          this.isLoginSuccess = true
          this.getDevicePort()
          this.channelTimer = window.setTimeout(() => {
            this.getChannelInfo()
          }, 1000)
        },
        error: (oError) => {
          this.showOPInfo(`${this.deviceIdentify} 登录失败：${oError.errorCode || '未知错误'}`)
          this.isLoginSuccess = false
        }
      })
    },

    handleLogout() {
      if (!this.deviceIdentify) return

      window.WebVideoCtrl.I_Logout(this.deviceIdentify).then(() => {
        this.showOPInfo(`${this.deviceIdentify} 退出成功！`)
        this.isLoginSuccess = false
        this.channels = []
        this.selectedChannel = ''
        this.deviceIdentify = ''
      }).catch(() => {
        this.showOPInfo(`${this.deviceIdentify} 退出失败！`)
      })
    },

    getDevicePort() {
      window.WebVideoCtrl.I_GetDevicePort(this.deviceIdentify).then((oPort) => {
        this.rtspPort = oPort.iRtspPort || 554
        this.showOPInfo(`获取设备端口成功，RTSP端口：${this.rtspPort}`)
      }).catch((oError) => {
        this.showOPInfo(`获取设备端口失败：${oError.errorCode}`)
      })
    },

    getChannelInfo() {
      this.channels = []

      window.WebVideoCtrl.I_GetAnalogChannelInfo(this.deviceIdentify, {
        success: (xmlDoc) => {
          const oChannels = $(xmlDoc).find("VideoInputChannel")
          oChannels.each((i, item) => {
            const id = $(item).find("id").eq(0).text()
            const name = $(item).find("name").eq(0).text() || `Camera ${i < 9 ? '0' + (i + 1) : (i + 1)}`
            this.channels.push({ id, name })
          })
          this.showOPInfo(`获取模拟通道成功，共${oChannels.length}个`)

          if (this.channels.length > 0 && !this.selectedChannel) {
            this.selectedChannel = this.resolvePreviewChannel()
          }
        },
        error: (oError) => {
          this.showOPInfo(`获取模拟通道失败：${oError.errorCode}`)
        }
      })

      window.WebVideoCtrl.I_GetDigitalChannelInfo(this.deviceIdentify, {
        success: (xmlDoc) => {
          const oChannels = $(xmlDoc).find("InputProxyChannelStatus")
          oChannels.each((i, item) => {
            const online = $(item).find("online").eq(0).text()
            if (online === 'false') return

            const id = $(item).find("id").eq(0).text()
            const name = $(item).find("name").eq(0).text() || `IPCamera ${i < 9 ? '0' + (i + 1) : (i + 1)}`
            this.channels.push({ id, name })
          })
          this.showOPInfo(`获取数字通道成功，共${oChannels.length}个`)

          if (this.channels.length > 0 && !this.selectedChannel) {
            this.selectedChannel = this.resolvePreviewChannel()
          }
        },
        error: (oError) => {
          this.showOPInfo(`获取数字通道失败：${oError.errorCode}`)
        }
      })

      this.playTimer = window.setTimeout(() => {
        this.startRealPlay()
      }, 1000)
    },

    resolvePreviewChannel() {
      if (!this.channels.length) return ''
      const preferred = this.info.channel == null ? '' : String(this.info.channel)
      const hit = preferred ? this.channels.find((item) => String(item.id) === preferred) : null
      return hit ? hit.id : this.channels[0].id
    },

    startRealPlay() {
      if (this.destroyed) return
      if (this.channels.length) {
        this.selectedChannel = this.resolvePreviewChannel()
      }
      if (!this.deviceIdentify || !this.selectedChannel) {
        this.showOPInfo('请先登录并选择通道！')
        return
      }
      const oWndInfo = window.WebVideoCtrl.I_GetWindowStatus(this.g_iWndIndex)
      const iStreamType = this.info.streamType != null ? Number(this.info.streamType) : 1
      const bZeroChannel = false
      const iChannelID = parseInt(this.selectedChannel, 10)

      console.log('iStreamType', iStreamType)
      console.log('iChannelID', iChannelID)
      console.log('bZeroChannel', bZeroChannel)
      console.log('iPort', this.rtspPort)
      console.log('deviceIdentify', this.deviceIdentify)

      const startPlay = () => {
        try {
          window.WebVideoCtrl.I_StartRealPlay(this.deviceIdentify, {
            iStreamType,
            iChannelID,
            bZeroChannel,
            iPort: this.rtspPort,
            success: () => {
              this.showOPInfo(`通道${this.selectedChannel}开始预览成功！`)
              $("#divPlugin").css("opacity", "1")
            },
            error: (oError) => {
              this.showOPInfo(`通道${this.selectedChannel}开始预览失败：${oError.errorCode}`)
            }
          })
        } catch (error) {
          console.warn(error)
        }
      }

      startPlay()
      this.handleResize()
    },

    stopRealPlay() {
      if (!window.WebVideoCtrl) return
      const oWndInfo = window.WebVideoCtrl.I_GetWindowStatus(this.g_iWndIndex)
      if (!oWndInfo) {
        this.showOPInfo('当前无预览视频！')
        return
      }

      window.WebVideoCtrl.I_Stop({
        success: () => {
          this.showOPInfo('停止预览成功！')
        },
        error: (oError) => {
          this.showOPInfo(`停止预览失败：${oError.errorCode}`)
        }
      })
    },

    handleResize() {
      let scale = 1
      if (window.WebVideoCtrl) {
        window.WebVideoCtrl.I_Resize($("#divPlugin").width() * scale, $("#divPlugin").height() * scale)
      }
    },

    clearTimers() {
      ['initTimer', 'channelTimer', 'playTimer'].forEach((key) => {
        if (this[key]) {
          window.clearTimeout(this[key])
          this[key] = null
        }
      })
    },

    clearPluginDom() {
      if ($ && $("#divPlugin")) {
        $("#divPlugin").html("")
        $("#divPlugin").css("opacity", "0")
      }
      const pluginContainer = document.getElementById("divPlugin")
      if (pluginContainer) {
        pluginContainer.innerHTML = ""
      }
    },

    hidePluginWindow() {
      if (!window.WebVideoCtrl) return
      try {
        if (typeof window.WebVideoCtrl.I_HideWndPlugin === 'function') {
          window.WebVideoCtrl.I_HideWndPlugin()
        }
      } catch (e) {
        console.warn('隐藏海康插件窗口失败', e)
      }
      try {
        window.WebVideoCtrl.I_Resize(0, 0)
      } catch (e) {
        console.warn('缩小海康插件窗口失败', e)
      }
    },

    teardownPlugin() {
      if (this.destroyed) return
      this.destroyed = true
      this.clearTimers()
      this.hidePluginWindow()
      this.stopRealPlay()
      this.handleLogout()
      if (window.WebVideoCtrl && typeof window.WebVideoCtrl.I_DestroyPlugin === 'function') {
        try {
          window.WebVideoCtrl.I_DestroyPlugin().then(() => {
            this.clearPluginDom()
          }).catch((err) => {
            console.warn("销毁插件失败", err)
            this.clearPluginDom()
          })
        } catch (e) {
          console.warn("销毁插件异常", e)
          this.clearPluginDom()
        }
      } else {
        this.clearPluginDom()
      }
    }
  }
}
</script>

<style scoped>
.hik-video-plugin {
  padding: 2px;
  width: 100%;
  height: 100%;
  text-align: left;
  position: relative;
}

#divPlugin {
  pointer-events: none;
  display: inline-block;
  width: 100%;
  height: 100%;
}

.hik-video-log {
  position: absolute;
  left: 8px;
  bottom: 8px;
  max-width: calc(100% - 16px);
  max-height: 120px;
  margin: 0;
  padding: 8px 10px;
  overflow: auto;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.58);
  color: #e5e7eb;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
  pointer-events: none;
}
</style>
